import {createEffect, createSignal, on} from 'solid-js'
import {useSelector} from '../../store'
import {ToastType} from '../toast/Toast'
import {useToast} from '../toast/useToast'
import {useConfig} from '../config/useConfig'
import {useI18n} from '../../../foundation'

export interface NotificationHandlingProps {
    children?: any
    ignoredNotification: string[]
    errorCodes: Record<string, any>
}

export enum NotificationType {
    failure = 'ERROR',
    success = 'SUCCESS',
    info = 'PLAIN',
}

export const NotificationHandling = (props: NotificationHandlingProps) => {
    const toast = useToast()
    const {getConfig} = useConfig()
    const {formatString, formatNotificationStringWithArgs} = useI18n()

    const notificationsLength = useSelector((s: any) => s.notifications?.queue.length)
    const notifications = useSelector((s: any) => s.notifications?.queue)
    const [shownNotificationsIds, setShownNotificationsIds] = createSignal<any[]>([])

    createEffect(
        on([() => notifications(), () => notificationsLength()], () => {
            notifications().forEach((n: any) => {
                const tag = Array.isArray(n.message.tag) ? n.message.tag : [n.message.tag]
                if (
                    !shownNotificationsIds().includes(n.id) &&
                    !tag.find((t: string) => props.ignoredNotification.includes(t))
                ) {
                    //global check to catch session error
                    let globalError = getConfig().customErrorMsg?.globalErrorMessages?.[tag?.[1]]
                    if (globalError) {
                        toast.show({
                            title: globalError?.title ?? n.type,
                            description: globalError?.description,
                            subDescription: globalError?.subDescription,
                            type: ToastType[NotificationType.failure],
                            sticky: globalError?.sticky ?? false,
                        })
                        setShownNotificationsIds([...shownNotificationsIds(), n.id])
                        return
                    }

                    const customMessage = getConfig().customErrorMsg[tag[0]]
                    const notificationMsg: string = tag.join(', ')
                    let errorMsg: string = ''
                    if (tag.length > 1 && tag[1] !== '') {
                        if (customMessage?.errorCode?.[tag?.[2]]) {
                            //if having duplicate error code then we check error msg for this is for checking error msg
                            errorMsg = customMessage?.errorCode?.[tag?.[2]]?.description
                        } else if (customMessage?.errorCode?.[tag?.[1]]) {
                            //Checking error code
                            errorMsg = customMessage?.errorCode?.[tag?.[1]]?.description
                                ? customMessage?.errorCode?.[tag?.[1]]?.description
                                : customMessage?.description
                        } else {
                            errorMsg = customMessage?.description
                        }
                    } else {
                        errorMsg = customMessage ? customMessage?.description : tag?.[0]?.description
                    }

                    let notificationErrorMsg = ''
                    if (n?.message?.argumentsValue) {
                        notificationErrorMsg = formatNotificationStringWithArgs(errorMsg, n?.message?.argumentsValue)
                    } else {
                        const notificationData = formatString(`notification`)
                        notificationErrorMsg = notificationData[errorMsg]
                    }
                    toast.show({
                        title: customMessage?.title,
                        description: notificationErrorMsg ?? tag?.[0]?.description,
                        subDescription: customMessage?.subDescription ?? props.errorCodes[tag[0]]?.description,
                        type: ToastType[NotificationType[n.type]],
                        sticky: customMessage?.sticky ?? false,
                        life: customMessage?.life ?? tag?.[0]?.life ?? undefined,
                    })
                    setShownNotificationsIds([...shownNotificationsIds(), n.id])
                }
            })
        })
    )

    return <>{props.children}</>
}
